import { getStoreConfig } from 'config'
export const getTitleWithTemplate = (updatedTitle: string) => {
    const config = getStoreConfig()
    const { seo } = config
    const template = seo?.default?.titleTemplate!
    if (template) {
        return template.replace('%s', updatedTitle)
    }
    return updatedTitle
}
